import { lazyWithRetry } from 'utils/chunkLoadRecovery';

export const PATH_PROFILE = '/pages/profile';

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: PATH_PROFILE,
      component: lazyWithRetry(() => import('app/pages/profile/ProfilePage')),
      isAllowedWithoutRoles: true,
    },
  ],
};

export default routesConfig;
